import React from 'react';
import SbEditable from 'storyblok-react';
import DynamicComponent from '~/components/DynamicComponent';

export default function TwoColumns({ blok }) {
  if (!blok) return null;
  const { content = [], className = '', containerClassName = '', reverse, gap = 12, leftWidth = 'md:w-1/2', alignItems = 'items-center' } = blok;
  const rightWidth = leftWidth.includes('1/2') ? leftWidth : leftWidth.includes('1/3') ? leftWidth.replace('1/3', '2/3') : 'flex-auto';
  const breakpointID = leftWidth.slice(0,2);

  return (
    <div>
      <SbEditable content={blok} key={blok._uid}>
        <div purgeclassname="pl-12 pl-16 pl-20 pl-24 -ml-12 -ml-16 -ml-20 -ml-24 md:w-1/2 md:w-1/3 lg:w-1/2 lg:w-1/3 md:w-2/3 lg:w-2/3" />

        <section className={className}>
          <div className="container">
            <div
              className={`flex flex-wrap items-center md:flex-nowrap -ml-${gap} space-y-12 md:space-y-0  ${reverse && 'md:flex-row-reverse'} ${containerClassName}`}
            >
              {content[0] && (
                <div className={`w-full md:w-auto flex-auto flex pl-${gap} ${leftWidth} ${alignItems} justify-center `}>
                  <DynamicComponent blok={content[0]} />
                </div>
              )}
              {content[1] && (
                <div className={`flex-auto flex pl-${gap} ${rightWidth} ${alignItems} justify-center`}>
                  <DynamicComponent blok={content[1]} />
                </div>
              )}
            </div>
          </div>
        </section>
      </SbEditable>
    </div>
  );
}
